module.exports = __webpack_public_path__ + "static/media/gb-eng.8fe6f9c7.svg";